import { render, staticRenderFns } from "./getOneself.vue?vue&type=template&id=198ec250&scoped=true&"
import script from "./getOneself.vue?vue&type=script&lang=js&"
export * from "./getOneself.vue?vue&type=script&lang=js&"
import style0 from "./getOneself.vue?vue&type=style&index=0&id=198ec250&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ec250",
  null
  
)

component.options.__file = "getOneself.vue"
export default component.exports